import { REPORT_TYPE_NAMES } from './actions/constants';

/* Analytics Events */
export const FEEDBACK_LOCATION_LO_CARD = 'QQ Insights LO Card';
export const FEEDBACK_LOCATION_ASSIGNMENT_CARD = 'QQ Insights Assignment Card';
export const FEEDBACK_LOCATION_ALTERNATIVE_LO_CARD =
  'QQ Alternative LOs Insights';
export const FEEDBACK_LOCATION_SCORE_SNAPSHOT_CARD = 'QQ Score Snapshot Card';
export const FEEDBACK_LOCATION_LOGIN_CARD = 'QQ Login Card';
export const FEEDBACK_LOCATION_TIMES_SCORE_CARD = 'QQ Time vs Score Card';
export const FEEDBACK_LOCATION_TIME_ATTEMPTS_CARD = 'QQ Time vs Attempts Card';
export const FEEDBACK_LOCATION_COMPLETED_ASSIGNMENT = 'QQ Completed Assignment';
export const FEEDBACK_LOCATION_SRL_CONFIDENCE_CARD = 'SRL Confidence Card';
export const FEEDBACK_LOCATION_SRL_GOAL_CARD = 'SRL Goal Card';
export const FEEDBACK_LOCATION_SRL_HOURS_CARD = 'SRL Hours Card';
export const FEEDBACK_LOCATION_SRL_GROWTH_CARD = 'SRL Growth Card';
export const FEEDBACK_LOCATION_SRL_CHALLENGES_CARD = 'SRL Challenges Card';
export const FEEDBACK_LOCATION_SRL_ACADEMICS_CARD = 'SRL Academics Card';
export const FEEDBACK_LOCATION_SRL_SPACING_PACING_CARD =
  'SRL Spacing and Pacing Card';
export const FEEDBACK_LOCATION_SRL_CHALLENGE_AND_RECALL_CARD =
  'SRL Challenge and Recall Card';
export const FEEDBACK_LOCATION_SRL_HELP_AND_COLLABORATION_CARD =
  'SRL Help and Collaboration Card';
export const FEEDBACK_LOCATION_SRL_ENVIRONMENT_AND_MINDSET_CARD =
  'SRL Environment and Mindset Card';

export const VIEW_NEW_INSIGHTS_WIDGET = {
  action: 'view',
  target: 'New Insights',
  loc: 'QQ Home Page Insight Widget',
};

export const CLICK_VIEW_INSIGHTS_BUTTON = {
  action: 'click',
  target: 'View Insights',
  loc: 'QQ Home Page New Insight Widget',
};

export const VIEW_QQ_INSIGHTS_REPORT = {
  action: 'view',
  target: 'QQ Insights Report',
  loc: 'QQ Insights Report',
};

export const VIEW_QQ_INSIGHTS_LO_MODAL = {
  action: 'view',
  target: 'QQ Insights Report LO Modal',
  loc: 'QQ Insights Report',
};

export const VIEW_QQ_INSIGHTS_ASSIGNMENT_MODAL = {
  action: 'view',
  target: 'QQ Insights Report Assignment Modal',
  loc: 'QQ Insights Report',
};

export const CLICK_LO_MODAL_VIEW_UNIT_BUTTON = {
  action: 'click',
  target: 'View Full Unit Report',
  loc: FEEDBACK_LOCATION_LO_CARD,
};

export const CLICK_INSIGHT_LO_MODAL_VIEW_ASSIGNMENTS = {
  action: 'click',
  target: 'View assignments',
  loc: 'QQ Insights LO Modal',
};

export const CLICK_INSIGHT_ASSIGNMENT_MODAL_VIEW_QUESTIONS = {
  action: 'click',
  target: 'View all questions',
  loc: 'QQ Insights Assignment Modal',
};

export const clickLeftNavigation = (title) => ({
  action: 'click',
  target: title,
  loc: 'Reports Tab Side Navigation',
});

export const clickLODetails = (reportType) => ({
  action: 'click',
  target: 'Expand LO Details',
  loc: `Performance by Learning Objective - ${
    REPORT_TYPE_NAMES[reportType] || 'Overview'
  }`,
});

export const clickByStudent = (reportType) => ({
  action: 'click',
  target: 'Student Name',
  loc: `Performance by Student - ${
    REPORT_TYPE_NAMES[reportType] || 'Overview'
  }`,
});

export const clickByAssignment = (reportType) => ({
  action: 'click',
  target: 'Assignment Title',
  loc: `Performance by Assignment - ${
    REPORT_TYPE_NAMES[reportType] || 'Overview'
  }`,
});

export const CLICK_PERFORMANCE_BY_UNIT = {
  action: 'click',
  target: 'Unit Title',
  loc: 'Performance by Unit - Overview Report',
};

export const clickBySubunit = (reportType) => ({
  action: 'click',
  target: 'Subunit Title',
  loc: `Performance by Subunit - ${
    REPORT_TYPE_NAMES[reportType] || 'Overview'
  }`,
});

export const viewReport = (reportType) => ({
  action: 'view',
  target: REPORT_TYPE_NAMES[reportType] || 'Unknown Report',
  loc: 'Reports Tab',
});

export const clickAccordion = (accordionTitle, reportType) => ({
  action: 'click',
  target: `${accordionTitle} Accordion`,
  loc: `${REPORT_TYPE_NAMES[reportType] || 'Overview'} Reports Tab`,
});

export const viewWidget = (reportType) => ({
  action: 'view',
  target: REPORT_TYPE_NAMES[reportType] || 'Unknown Report',
  loc: 'Course Home',
});

export const selectAssignment = (item) => ({
  action: 'click',
  target: item.label || 'N/A',
  assignment_id: item.value || 'N/A',
  loc: 'GRS Showing Results For',
});

export const viewInsights = (data) => ({
  action: 'click',
  target: 'View More',
  loc: data.location,
  assignment_id: data.assignment_id,
});

export const viewStudentDetails = (data) => ({
  action: 'click',
  target: 'Student Name',
  loc: data.location,
  assignment_id: data.assignment_id,
});

export const closeInsights = (data) => ({
  action: 'click',
  target: 'Close Insights',
  loc: data.location,
  assignment_id: data.assignment_id,
});
